import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import { labRequestReportRoi } from '../../../helpers/adipiBackendUrl';
import { getTable, postApiCall } from "../../../services/mainServices";
import {
  ADD_NEW_LABREQUESTREPORTROI,
  DELETE_LABREQUESTREPORTROI,
  GET_LABREQUESTREPORTROIS,
  UPDATE_LABREQUESTREPORTROI
} from "./actionTypes";
import {
  addLabRequestReportRoiFail,
  addLabRequestReportRoiSuccess,
  deleteLabRequestReportRoiFail,
  deleteLabRequestReportRoiSuccess,
  getLabRequestReportRoisFail,
  getLabRequestReportRoisSuccess,
  setState,
  updateLabRequestReportRoiFail,
  updateLabRequestReportRoiSuccess,
} from "./actions";

//Include Both Helper File with needed methods

function* fetchLabRequestReportRois( { payload: { params } } ) {
  try {
    yield put(setState(true))
    const response = yield call(getTable,labRequestReportRoi, params.toString());
    yield put(setState(false))
    yield put(getLabRequestReportRoisSuccess(response.items,response.totalPages, response.currentPage));
  } catch (error) {
    yield put(setState(false))
    yield put(getLabRequestReportRoisFail(error));
  }
}

function* updateLabRequestReportRoi ({payload: labRequestReportRoiObj }) {
  try {
    const response = yield call(getTable,`${labRequestReportRoi}/${labRequestReportRoiObj.id}`);
    yield put(updateLabRequestReportRoiSuccess(response));
  } catch (error) {
    yield put(updateLabRequestReportRoiFail(error));
  }
}

function* deleteLabRequestReportRoi ({payload: labRequestReportRoiObj}) {
  try {
    yield put(deleteLabRequestReportRoiSuccess(labRequestReportRoiObj.id));
  } catch (error) {
    yield put(deleteLabRequestReportRoiFail(error));
  }
}

function* postingLabRequestReportRoi ({ payload: labRequestReportRoiObj}) {
  try {
    const response = yield call(postApiCall, labRequestReportRoi ,labRequestReportRoiObj);
    const response2 = yield call(getTable,`${labRequestReportRoi}/${response.id}`);
    yield put(addLabRequestReportRoiSuccess(response2));
  } catch (error) {
    yield put(addLabRequestReportRoiFail(error));
  }
}

function* labRequestReportRoisSaga() {
  yield takeEvery(GET_LABREQUESTREPORTROIS, fetchLabRequestReportRois);
  yield takeEvery(ADD_NEW_LABREQUESTREPORTROI, postingLabRequestReportRoi);
  yield takeEvery(UPDATE_LABREQUESTREPORTROI, updateLabRequestReportRoi);
  yield takeEvery(DELETE_LABREQUESTREPORTROI, deleteLabRequestReportRoi);
}

export default labRequestReportRoisSaga;
